import { render, staticRenderFns } from "./daily-add.vue?vue&type=template&id=615cd4f8&scoped=true&"
import script from "./daily-add.vue?vue&type=script&lang=js&"
export * from "./daily-add.vue?vue&type=script&lang=js&"
import style0 from "./daily-add.vue?vue&type=style&index=0&id=615cd4f8&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615cd4f8",
  null
  
)

export default component.exports